<template>
  <zm-drawer
    :title="title"
    :width="drawerWidth"
    :visible="visible"
    size="large"
    @cancel="open(false)"
    :footer="false"
  >
    <div slot="drawerBody">
      <a-form :form="form">
        <div class="title">合同详情</div>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称">
              <a-input
                placeholder="请输入合同名称"
                id="name"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入合同名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同编号">
              <a-input
                placeholder="请输入合同编号"
                id="number"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['number', { rules: [{ required: true, message: '请输入合同编号！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="是否关联销售合同">
              <a-switch
                v-decorator="['relationContractState', { valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"
                :disabled="!isEdit"
              ></a-switch>
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联合同名称">
              <a-select
                placeholder="请选择关联合同名称"
                :disabled="!isEdit || !isRelationContractState"
                v-decorator="['contractName', { rules: [{ required: true, message: '请选择关联合同名称！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目名称">
              <a-select
                placeholder="请选择项目名称"
                :disabled="!isEdit || isShowProductName"
                v-decorator="['projectName', { rules: [{ required: true, message: '请选择项目名称！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-select
                placeholder="请选择供应商"
                :disabled="!isEdit"
                v-decorator="['supplierName', { rules: [{ required: true, message: '请选择供应商！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内容类型">
              <a-select
                placeholder="请选择内容类型"
                :disabled="!isEdit"
                v-decorator="['contentTypeDesc', { rules: [{ required: true, message: '请选择内容类型！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签约日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择签约日期"
                v-decorator="['signDate', { rules: [{ required: true, message: '请选择签约日期！' }] }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质保期限">
              <a-select
                placeholder="请选择质保期限"
                :disabled="!isEdit"
                v-decorator="['maintainExpiresDesc', { rules: [{ required: true, message: '请选择质保期限！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="验收日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择验收日期"
                v-decorator="['checkDate', { rules: [{ required: true, message: '请选择验收日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人">
              <a-select
                placeholder="请选择经办人"
                :disabled="!isEdit"
                v-decorator="['operatorName', { rules: [{ required: true, message: '请选择经办人！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额">
              <a-input
                placeholder="请输入合同金额"
                id="contractAmount"
                autocomplete="off"
                :disabled="!isEdit"
                v-decorator="['contractAmount', { rules: [{ required: true, message: '请输入合同金额！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider style="margin: 16px 0"></a-divider>

        <div class="title">采购物品信息</div>
        <!-- 此处循环 -->

        <div v-for="(item,index) in model.inquiryProductList" :key="index">
          <a-row>
            <a-col :span="10">
              <a-form-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="采购物品">
                <a-select
                  placeholder="请选择采购物品"
                  v-decorator="[
                    `inquiryProductId[${item}]`,
                    {
                      initialValue: item.name,
                      rules: [{ required: true, message: '请选择采购物品' }],
                    },
                  ]"
                  :disabled="!isEdit"
                >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购数量">
                <a-input
                  placeholder="请输入采购数量"
                  v-decorator="[
                    `num[${item}]`,
                    {
                      initialValue: item.num,
                      rules: [{ required: true, message: '请输入采购数量！' }],
                    },
                  ]"
                  :disabled="!isEdit"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-form-item>
                <a-select
                  placeholder="单位"
                  v-decorator="[
                    `unit[${item}]`,
                    {
                      initialValue: item.unitDesc,
                      rules: [{ required: true, message: '请选择单位！' }],
                    },
                  ]"
                  :disabled="!isEdit"
                >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单价" :extra="`总价：${item.totalPrice}元`">
                <a-input
                  placeholder="请输入采购单价"
                  v-decorator="[
                    `price[${item}]`,
                    {
                      initialValue: item.price,
                      rules: [{ required: true, message: '请输入采购单价！' }],
                    },
                  ]"
                  :disabled="!isEdit"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <a-divider style="margin: 16px 0"></a-divider>

        <div class="title">付款方式</div>
        <!-- 此处循环 -->


        <div v-for="(item,index) in model.payments" :key="index+'*_*'">
          <a-row>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="款项类型">
                <a-select
                  placeholder="请选择款项类型"
                  v-decorator="[
                    `paymentType[${item}]`,
                    {
                      initialValue: item.paymentTypeDesc,
                      rules: [{ required: true, message: '请选择款项类型' }],
                    },
                  ]"
                  :disabled="!isEdit"
                >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划付款">
                <a-date-picker
                  style="width: 100%"
                  placeholder="请选择计划付款"
                  v-decorator="[
                    `paymentDatePlan[${item}]`,
                    {
                      initialValue: momentDate(item.paymentDatePlan),
                      rules: [{ required: true, message: '请选择计划付款' }],
                    },
                  ]"
                  :disabled="!isEdit"
                />
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款比例">
                <a-input
                  placeholder="请输入付款比例"
                  autocomplete="off"
                  addon-after="%"
                  v-decorator="[
                    `paymentRatio[${item}]`,
                    {
                      initialValue: Ratio(item.paymentRatio),
                      rules: [{ required: true, message: '请输入收款比例' }],
                    },
                  ]"
                  :disabled="!isEdit"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">附件上传</div>
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="合同附件"
              :labelCol="{ xs: { span: 24 }, sm: { span: 2 } }"
              :wrapperCol="{ xs: { span: 24 }, sm: { span: 22 } }"
            >
              <zm-preview
                :list="fileList"
                :baseUrl="$sysInfo.apiRemote"
                :previewUrl="$sysInfo.previewUrl"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/contract/purchase/file/"
              ></zm-preview>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'editPurchases',
  mounted() {
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth() {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({}),
  },
  data() {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'purchases' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      colSpan: 6,
      fileList: [],
      //是否关联销售合同
      isRelationContractState: null,
      //是否禁用项目名称
      isShowProductName:null
    }
  },
  methods: {
    // 设置类型
    setType(type) {
      this.type = type
    },
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.visible = flag
      console.log(this.model)
      if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
        if (flag) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              name: this.model.name,
              number: this.model.number,
              relationContractState: this.model.relationContractState,
              contractName: this.model.contractName,
              projectName: this.model.projectName,
              supplierName: this.model.supplierName,
              contentTypeDesc: this.model.contentTypeDesc,
              signDate: moment(this.model.signDate),
              maintainExpiresDesc: this.model.maintainExpiresDesc,
              checkDate: moment(this.model.signDate),
              operatorName: this.model.operatorName,
              contractAmount: this.model.contractAmount,
            })
          })
          //编辑时初始化关联bool
          this.isRelationContractState = this.model.relationContractState
          //编辑时初始化禁用项目名称bool
          this.isShowProductName = this.model.relationContractState
          this.fileList = this.model.files
        }
      }
    },
    momentDate(val) {
      return moment(val)
    },
    Ratio(val) {
      return Number(val) * 100
    }
  },
}
</script>

<style scoped lang="less">
.title {
  font-weight: bold;
  margin-bottom: 10px;
}
.title::before {
  display: inline-block;
  width: 4px;
  height: 12px;
  background: #1791ff;
  content: '';
  margin-right: 7px;
}
</style>

